import React from "react";
import ModuleNavigation from "../ModuleNavigation";

export default function MaintenanceModule() {
  return <ModuleNavigation moduleId="MaintenanceModule" />;
}
